import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=286504d0"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286504d0')) {
      api.createRecord('286504d0', component.options)
    } else {
      api.reload('286504d0', component.options)
    }
    module.hot.accept("./TextIcon.vue?vue&type=template&id=286504d0", function () {
      api.rerender('286504d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/TextIcon.vue"
export default component.exports